export default function uniqueId() {
  return Math.random()
    .toString(16)
    .slice(2);
}
